import { useErrValidationFailedContext } from "@/shared/lib/errors/err-validation-failed-context";
import { ServiceObjectReferencesBase } from "../types/service-object-references-base";

export function useResetRemovedServiceObjectFields() {
  const { resetFields } = useErrValidationFailedContext();

  return (references: ServiceObjectReferencesBase, newIds: string[]) => {
    for (const { serviceObjectId } of references.serviceObjects) {
      if (!newIds.includes(serviceObjectId)) {
        resetFields(`serviceObjects.${serviceObjectId}`);
      }
    }
  };
}
